import { Dashboard } from "../components/Dashboard";
import { LoadingScreen } from "../components/LoadingScreen";
import { PublicGate } from "../components/PublicGate";
import { useSession } from "../hooks/useSession";

export function ProtectedDashboard() {
  const [result, refresh] = useSession();

  if (result.kind === "loading") {
    return <LoadingScreen />;
  }

  if (result.kind === "signed_out") {
    return (
      <PublicGate
        eyebrow="Diffex workspace"
        title="Sign in to continue"
        detail="Your workspace is private. Diffex will take you to its secure sign-in page."
      />
    );
  }

  if (result.kind === "access_not_provisioned") {
    return (
      <PublicGate
        eyebrow="Access required"
        title="Your workspace is not provisioned"
        detail="A Diffex invitation and an active organization membership are required."
        requestId={result.requestId}
      />
    );
  }

  if (result.kind === "temporarily_unavailable") {
    return (
      <PublicGate
        eyebrow="Service interruption"
        title="We cannot reach your workspace"
        detail="Your session has not been changed. Try the request again in a moment."
        requestId={result.requestId}
        retry={refresh}
      />
    );
  }

  if (result.kind === "authentication_error") {
    return (
      <PublicGate
        eyebrow="Authentication error"
        title="We could not verify this session"
        detail="Try signing in again. If the issue continues, contact Diffex support."
        requestId={result.requestId}
      />
    );
  }

  return <Dashboard session={result.session} />;
}
